import { createContext, useContext, useEffect, type ReactNode } from 'react';
import type { ThemeContract } from './theme-contract';
import { applyTheme, removeTheme } from './apply-theme';

interface ThemeContextValue {
  theme?: Partial<ThemeContract>;
}

const ThemeContext = createContext<ThemeContextValue>({});

export interface ThemeProviderProps {
  theme?: Partial<ThemeContract>;
  children: ReactNode;
}

export function ThemeProvider({ theme, children }: ThemeProviderProps) {
  useEffect(() => {
    applyTheme(theme);
    return () => removeTheme();
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
